// extracted by mini-css-extract-plugin
export var menuIcon = "_p1-0";
export var menuIconInline = "_p1-1";